const PrivateSwitchBase = {
  styleOverrides: {
    root: {
      padding: 6,
    },
  },
}

export default PrivateSwitchBase
